import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
    serviceCategory: {
        label: "",
        letter: ""
    },
    serviceCategoryList: [

    ]
}

const serviceCategory = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
export default serviceCategory;